/** Whether a keydown is the ⌘K / Ctrl+K shortcut. */
export const isPaletteShortcut = (event: KeyboardEvent): boolean => {
    // Autofill can dispatch keydown events without a key.
    const key = (event as { key?: string }).key;
    return !event.repeat && (event.metaKey || event.ctrlKey) && key?.toLowerCase() === 'k';
};
